<template>
  <div>
    <div class="title order" v-if="item">
      <h1>{{ $t("订单信息") }}</h1>
      <p>{{ $t("商品品类/数量") }}：{{ item.quantity }}</p>
      <p>{{ $t("订单编号") }}：{{ item.ordernum }}</p>
      <p>{{ $t("下单时间") }}：{{ item.created.date }}</p>
      <p>{{ $t("供货商") }}：{{ item.supplier_name }}</p>
      <p>{{ $t('供货商电话') }}：{{ item.supplier_phone }}</p>
      <!-- <p>{{ $t("收货人") }}：{{ item.receiver }}</p> -->
      <p>{{ $t("付款状态") }}：{{ item.status_text }}</p>
      <!-- <p>{{ $t("花材备注") }}：</p> -->
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom"

export default defineComponent({
  props: { item: Object },
  setup() {
    return {}
  },
})
</script>

<style scoped lang="scss">
.title {
  text-align: start;
  > h1 {
    font-size: 1.125rem;
    margin-bottom: 1rem;
    font-weight: bold;
  }
  > p {
    margin-bottom: 0.5rem;
  }
}
</style>
